<template>
    <repeater
        :list="events"
        :index="getEventIndex"
        table-class="table-hoverable"
        row-class="clickable"
    >
        <colgroup slot="colgroup">
            <col style="width:220px">
            <col style="width:220px">
            <col>
        </colgroup>
        <template slot="iteratee" slot-scope="{item}">
            <td>
                <div>
                    <router-link
                        v-if="hasRuleSetAccess"
                        :to="{name: eventRoute, params: {eventType: item.eventType}}">
                        {{item.eventType | unKebabCase}}</router-link>
                    <span v-else>{{item.eventType | unKebabCase}}</span>
                </div>
            </td>
            <td>
                <slot name="badges" :item="item">
                    <div class="chip chip-s chip-secondary inline-s" v-if="item.hasRules">
                        <span class="inline-s">Rules</span><r-badge>{{item.rulesCount}}</r-badge>
                    </div><div class="chip chip-s chip-secondary" v-if="item.hasBinds">
                        <span class="inline-s">Binds</span><r-badge>{{item.bindsCount}}</r-badge>
                    </div>
                </slot>
            </td>
            <td>
                <div>{{item.description | coverEmpty}}</div>
            </td>
        </template>
    </repeater>
</template>

<script>
    import Repeater from '@/components/repeater/repeater';

    export default {
        name: 'event-list',
        components: {Repeater},
        props: {
            events: Array,
            eventRoute: {
                default: 'view-system-event',
                type: String,
            },
        },
        computed: {
            hasRuleSetAccess() {
                return this.$auth.rulesets.read.isAllowed;
            },
        },
        methods: {
            getEventIndex(event) {
                return event.eventType;
            },
        },
    };
</script>
